/* eslint-disable react-hooks/set-state-in-effect */
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProjectCtx = createContext(null);

export const ProjectProvider = ({ children }) => {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data.items);
      if (!activeId && data.items.length > 0) {
        const stored = localStorage.getItem("ciq_active_project");
        const match = data.items.find((p) => p.id === stored);
        setActiveId(match ? match.id : data.items[0].id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeId]);

  useEffect(() => {
    if (user) refresh();
    else {
      setProjects([]);
      setActiveId(null);
    }
  }, [user, refresh]);

  const selectProject = (id) => {
    setActiveId(id);
    localStorage.setItem("ciq_active_project", id);
  };

  const active = projects.find((p) => p.id === activeId) || null;

  return (
    <ProjectCtx.Provider value={{ projects, active, activeId, selectProject, refresh, loading }}>
      {children}
    </ProjectCtx.Provider>
  );
};

export const useProjects = () => useContext(ProjectCtx);
